import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import Checkbox from "components/library/Checkbox";
import { setFilter, unsetFilter } from "dashboard/actions/filters";
import { getDashboardListAsync } from "dashboard/actions/list";

import styles from "./FilterCheckbox.css";

const mapStateToProps = state => ({ filters: state.dashboard.filters });
const mapDispatchToProps = { setFilter, unsetFilter, getDashboardListAsync };

class FilterCheckbox extends Component {
  constructor(props) {
    super(props);

    this.isFilterActive = this._isFilterActive.bind(this);
    this.handleCheckboxToggle = this._handleCheckboxToggle.bind(this);
  }

  _isFilterActive(filter) {
    return Object.keys(filter)[0] in this.props.filters;
  }

  _handleCheckboxToggle() {
    if (this.isFilterActive(this.props.filter)) {
      this.props.unsetFilter(Object.keys(this.props.filter)[0]);
    } else {
      this.props.setFilter(this.props.filter);
    }
    this.props.getDashboardListAsync();
  }

  render() {
    return (
      <div className={styles.root}>
        <Checkbox
          label={this.props.label}
          onChange={this.handleCheckboxToggle}
          isChecked={this.isFilterActive(this.props.filter)}
        />
      </div>
    );
  }
}

FilterCheckbox.propTypes = {
  filter: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FilterCheckbox);
